import { Box, Button, Flex, Image } from '@chakra-ui/react';

import Modal from '../../../../../../components/Modal';
import { PhotoEntry } from '../buildPhotoSlotMap';

type PhotoLightboxProps = {
  isOpen: boolean;
  onClose: () => void;
  photo: PhotoEntry | undefined;
  slotLabel: string;
  onReplace: () => void;
  onDelete: () => void;
};

const PhotoLightbox = ({
  isOpen,
  onClose,
  photo,
  slotLabel,
  onReplace,
  onDelete,
}: PhotoLightboxProps) => {
  const handleReplace = () => {
    onClose();
    setTimeout(onReplace, 0);
  };

  const handleDelete = () => {
    onClose();
    onDelete();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={slotLabel}
      titleFontSize="lg"
      titleFontWeight="600"
      size="xl"
      _content={{ maxW: '700px' }}
      _body={{ p: 0 }}
    >
      {photo && (
        <Box>
          <Image
            src={photo.previewUrl}
            alt={slotLabel}
            w="100%"
            maxH="500px"
            objectFit="contain"
            bg="gray.100"
          />
          <Flex justify="center" gap={4} p={4}>
            <Button
              variant="outline"
              color="oceanBoatBlue"
              borderColor="oceanBoatBlue"
              _hover={{ bg: 'iceBlue' }}
              onClick={handleReplace}
            >
              Replace
            </Button>
            <Button variant="dangerOutline" onClick={handleDelete}>
              Delete
            </Button>
          </Flex>
        </Box>
      )}
    </Modal>
  );
};

export default PhotoLightbox;
